import React from 'react';
import {  Route, Routes } from 'react-router-dom';
import Navbar from './Navbar/index';
import Home from './Components/Home/index';
import ParentAll from './Components/Parents/allstudent';
import ParentNew from './Components/Parents/request';
import RMAll from './Components/RMs/allrm';
import MathOperations from './Components/Operations/math';
import '../../App.css'
function App() {
  return (
    <div className="App">
      <Routes>
          <Route path="/" element={<Navbar/>} />
          <Route path="/home" element={<Home/>} />
          <Route path="/parent/all" element={<ParentAll/>} />        
          <Route path="/parent/new" element={<ParentNew/>} />        
          <Route path="/rm/allrm" element={<RMAll/>} />        
          <Route path="/operations/math" element={<MathOperations/>} />                 
      </Routes>
    </div>
  );
}

export default App;